import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {

  constructor() {}

  private fileType : string = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  private fileExtension : string = '.xlsx';

  public initCols(colNameList): Array<any> {
    let cols = [];

    colNameList.forEach((name) => {
        cols.push({ wch: name.length + 1 });
    });
    return cols;
  }

  public extendCols(cols): Array<any> {
    return cols.map((col) => { col.wch += 1; return col; });
  }

  public exportExcel(jsonData: any[], fileName: string, cols?: any[]): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData);
    if (cols) {
      worksheet['!cols'] = cols;
    }
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    this.saveExcelFile(excelBuffer, fileName);
  }

  private saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {type: this.fileType});

    FileSaver.saveAs(data, fileName + this.fileExtension);
  }

}
